import {
    ADD_BOT_MESSAGE,
    ADD_MESSAGE,
    CLEAR_CHAT_BOT,
    DISABLE_DATE_PICKER,
    LOADING_BOT_MESSAGE,
    SET_CHAT_BOT_MESSAGE_VALUE,
    SET_INPUT_DISABLE,
    SET_SELECTED_DAY,
    SET_SELECTED_TIME,
    SET_USER_INFOS
} from "../actions/PlanDemand";

import {isNight} from "../utils/isNight";

export const getTime = () => {
    let currentDate = new Date();
    let hour = currentDate.getHours();
    let minutes = currentDate.getMinutes();
    let day = currentDate.getUTCDate();
    let month = currentDate.getMonth();
    let year = currentDate.getFullYear();
    if (day < 10) {
        day = "0" + day;
    }
    if (month < 10) {
        month = "0" + (month + 1);
    }
    if (minutes < 10) {
        minutes = "0" + (minutes);
    }
    let time = day + "/" + month + "/" + year + " à " + hour + ":" + minutes;
    return time;
};

export const initialState = {
    inputDisabled: false,
    disableDatePicker: true,
    botIsLoading: false,
    userInfos:
        {
            "firstname": "",
            "lastname": "",
            "tel": "",
            "route": "",
            "city": "",
            "cp": "",
            "resume": ""
        },
    messageValue: "",
    messages: [
        {
            "type": "bot",
            "message":
                (isNight() ? "Bonsoir,\n" : "Bonjour,\n") +
                "Vous êtes sur le point de faire une demande de rappel par un.e Care Manager pour vous aider et accompagner votre proche. Durant ce bref échange vous conviendrez ensemble d’une date de rendez-vous pour que votre Care Manager puisse vous apporter une écoute active, des conseils experts et coordonner, si vous le souhaitez, les différentes actions à mener dans le parcours de soin de votre proche. \n" +
                "\n" +
                "Nous avons besoin de mieux vous connaitre, nous allons donc vous poser quelques questions (temps nécessaire : 2 minutes). Après avoir renseigné les informations demandées, un.e Care Manager vous rappellera en 4h ouvrées. Êtes-vous prêt.e ?",
            "date": "Envoyé le " + getTime()
        }
    ],
    selectedDay: "",
    selectedTime: "",
};

// @Todo : On pourrait repenser les deux Reducers plandemand et freeQuestionChatBot pour les mutualiser.
// @Todo : Cela demanderait un travail de refactorisation assez conséquent.
const planDemand = (state = initialState, action = {}) => {
    switch (action.type) {
        // Change la valeur du message afficher par le bot
        case SET_CHAT_BOT_MESSAGE_VALUE: {
            return {
                ...state,
                messageValue: action.value
            };
        }
        // Ajoute le message envoyé par le user via le chatbot
        case ADD_MESSAGE : {

            const newMessage = [...state.messages];
            newMessage.push({
                "type": "user",
                "message": action.message,
                "date": "Envoyé le " + getTime()
            });
            return {
                ...state,
                messageValue: "",
                messages: newMessage
            };
        }
        // Ajoute le message du bot
        case ADD_BOT_MESSAGE : {
            const newMessage = [...state.messages];
            newMessage.push({
                "message": action.message,
                "type": action.messageType,
                "date": "Envoyé le " + getTime()
            });
            return {
                ...state,
                messageValue: "",
                messages: newMessage
            };
        }
        // Permet de rendre l'input inactif lors du chargement de l'envoie du bot message
        case SET_INPUT_DISABLE : {
            return {
                ...state,
                inputDisabled: action.bool
            };
        }
        // Permet de disable le bouton envoyer du datepicker lors d'un chargement (évite les multi clique)
        case DISABLE_DATE_PICKER : {
            return {
                ...state,
                disableDatePicker: action.bool
            };
        }
        // Détermine les coordonnées rentré par le user dans le chat bot
        case SET_USER_INFOS : {
            // const newUserInfo = [...state.userInfos];
            if (action.infoType === "firstname") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "firstname": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }

            if (action.infoType === "lastname") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "lastname": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }

            if (action.infoType === "tel") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "tel": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }

            if (action.infoType === "route") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "route": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }
            if (action.infoType === "city") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "city": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }
            if (action.infoType === "cp") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "cp": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }
            if (action.infoType === "resume") {
                const newUserInfo =
                    {
                        ...state.userInfos,
                        "resume": action.value,
                    };
                return {
                    ...state,
                    userInfos: newUserInfo
                };
            }
            return {
                ...state
            };
        }
        // Met à jour la valeur du jour sélectionné via le calendrier
        case SET_SELECTED_DAY : {
            return {
                ...state,
                selectedDay: action.day
            };
        }
        // Met à jour le crénau horaire sélectionné par le user après avoir sélectionné un jour du calendrier
        case SET_SELECTED_TIME : {
            return {
                ...state,
                selectedTime: action.time
            };
        }
        // Permet d'afficher l'animation lors de la simulation d'écriture d'un bot message
        case LOADING_BOT_MESSAGE : {
            return {
                ...state,
                botIsLoading: action.bool
            };
        }
        // Reset du composant bot
        case CLEAR_CHAT_BOT : {
            return {
                ...state,
                messages: [
                    {
                        "type": "bot",
                        "message":
                            (isNight() ? "Bonsoir," : "Bonjour,\n") +
                            "Vous êtes sur le point de faire une demande de rappel par un.e Care Manager pour vous aider et accompagner votre proche. Durant ce bref échange vous conviendrez ensemble d’une date de rendez-vous pour que votre Care Manager puisse vous apporter une écoute active, des conseils experts et coordonner, si vous le souhaitez, les différentes actions à mener dans le parcours de soin de votre proche. \n" +
                            "\n" +
                            "Nous avons besoin de mieux vous connaitre, nous allons donc vous poser quelques questions (temps nécessaire : 2 minutes). Après avoir renseigné les informations demandées, un.e Care Manager vous rappellera en 4h ouvrées. Êtes-vous prêt.e ?",
                        "date": "Envoyé le " + getTime()
                    }
                ],
                messageValue: "",
                userInfos: {
                    "firstname": "",
                    "lastname": "",
                    "tel": "",
                    "route": "",
                    "city": "",
                    "cp": "",
                    "resume": ""
                },
                selectedDay: "",
                selectedTime: "",
            };
        }
        default:
            return state;
    }
};

export default planDemand;

